export const Header = (function () {
	'use strict';

	let isMobile = (window.ontouchstart === null) ? true : false;
	const tap = (window.ontouchstart === null) ? 'touchstart' : 'click';
	const tapl = (window.ontouchstart === null) ? 'touchstart' : 'mouseenter';
	let header, menu, menu_button, anchors;

	function init() {
		header = $('.site-header');
		if (!header.length) return;
		menu = $('.site-header > nav');
		menu_button = $('.site-header__menu').find('.mobile-menu-button');

		anchorActions();
		primaryMenu();
		secondaryMenu('locations');
		secondaryMenu('translations');
		showCurrentFlag();
		hideCurrentLocation();
	}

	function hideCurrentLocation() {
		// Get the text inside the button
		var buttonText = $(".site-header__locations button h2").text();

		// Find the LI element with the same text and hide it
		$("#menu-locations li").each(function () {
			if ($(this).text() === buttonText) {
				$(this).hide();
				return false; // Stop iterating once a match is found
			}
		});

	}

	function anchorActions() {
		anchors = header.find('a');
		if (anchors.length > 0) {
			anchors.each(function (index) {
				const anchor = $(this);
				const anchorHash = anchor.prop('href').split('#');

				if (anchorHash[1]) {
					anchor.on(tap, function (e) {
						setTimeout(function () {
							if (isMobile) {
								closeSecondaryMenu('locations');
								closeSecondaryMenu('translations');
							}
							closePrimaryMenus();
						}, 500);
					});
				}
			});
		}
	}

	function closePrimaryMenus() {
		$('body').removeClass('menu-open');
		menu.attr('aria-expanded', 'false');
		menu_button.attr('aria-expanded', 'false');
	}

	function closeSecondaryMenu(menu_name) {
		var currmenu = $('.site-header__' + menu_name);
		if (!currmenu.length) return;
		$('.site-header__' + menu_name).removeClass('active');
		$('.site-header__' + menu_name).find('.mobile-menu-button').attr('aria-expanded', 'false');
	}

	// Locations Nav
	// mobile: opens on tap, closes on top
	// desktop: opens on hover, closes 1 sec after mouse leaves
	// Aaron Silver
	function secondaryMenu(menu_name) {
		var currmenu = $('.site-header__' + menu_name);
		var currmenu_button = currmenu.find('.mobile-menu-button');
		if (!currmenu_button.length) return;

		// Desktop & Mobile: open the subnav on hover/tap
		currmenu_button.on(tapl, function (e) {
			e.preventDefault();
			closePrimaryMenus(); // close the main nav, if it's open

			if ($(this).attr('aria-expanded') === 'true' && isMobile) {
				closeSecondaryMenu(menu_name);
			} else {
				currmenu.addClass('active');
				$(this).attr('aria-expanded', 'true');
			}
		});

		// Desktop: close the subnav 1 sec after the mouse leaves the whole div
		currmenu.on('mouseleave', function (e) {
			setTimeout(function () {
				// if the mouse is not currently on the div, close.
				if ($('.site-header__' + menu_name + ':hover').length == 0) {
					closeSecondaryMenu(menu_name);
				}
			}, 1000);
		});
	}

	function primaryMenu() {
		if (!menu_button.length) return;

		menu_button.on(tap, function (e) {
			e.preventDefault();
			closeSecondaryMenu('locations');
			closeSecondaryMenu('translations');
			if ($(this).attr('aria-expanded') === 'true') {
				closePrimaryMenus();
			} else {
				$('body').addClass('menu-open');
				menu.attr('aria-expanded', 'true');
				$(this).attr('aria-expanded', 'true');
			}
		});

		// watch all of the top-level items in the main nav
		let children = menu.find('#menu-main-navigation > .menu-item');

		if (children.length > 0) {
			children.each(function () {
				let child = $(this);
				let child_link = child.children().eq(0);
				let child_menu = child.children().eq(1);

				// for every hover/tap, close everything, then open the appropriate submenu, if applicable
				child_link.on(tapl, function (e) {
					let closeMe = $(this).hasClass('active');
					// close all siblings/children
					children.each(function () {
						$(this).children().eq(0).removeClass('active');
						$(this).children().eq(1).attr('aria-expanded', 'false');
					});
					// open this child (if isMobile, only open it if it wasn't already open)
					if ((child.hasClass('menu-item-has-children') && !isMobile) || (isMobile && !closeMe)) {
						$(this).addClass('active');
						child_menu.attr('aria-expanded', 'true');
					}
				});
			});
		}

	}

	function showCurrentFlag() {
		// Get the flag of the current item (which is hidden by css)
		var active_item = $('.translations_nav .current-menu-item');
		if (!active_item.length) return;

		var classes = active_item.attr('class').split(' ');
		var flagClass = null;
		for (var i = 0; i < classes.length; i++) {
			if (classes[i].startsWith('flag-')) {
				flagClass = classes[i];
				break; // Exit the loop since we found the class
			}
		}
		// change the global icon's span to have that class instead
		$('.mobile-menu-button span').removeClass('flag-globe').addClass(flagClass)
	}

	return {
		init: init,
	};
})();
